import React from "react";
import { LuSettings, LuSettings2 } from "react-icons/lu";

const baseProps = (size, color, strokeWidth, className) => ({
  width: size ?? 24,
  height: size ?? 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color ?? "currentColor",
  strokeWidth: strokeWidth ?? 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className,
});

export const DashboardIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <rect x="3" y="3" width="7" height="11" rx="1.5" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" />
    <rect x="3" y="18" width="7" height="3" rx="1.5" />
  </svg>
);

export const PatientsIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <path d="M16 3.5a4 4 0 0 1 0 7" />
  </svg>
);

export const ChargesIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

export const SubmissionsIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="9" y1="13" x2="15" y2="13" />
    <line x1="9" y1="17" x2="13" y2="17" />
  </svg>
);

export const InsurancePaymentsIcon = ({
  size,
  color,
  strokeWidth,
  className,
} = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
    <path d="M6 15h2M10 15h4" />
  </svg>
);

export const EobParserIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.35-4.35" />
    <path d="M8 11h6M11 8v6" />
  </svg>
);

export const PatientPaymentsIcon = ({
  size,
  color,
  strokeWidth,
  className,
} = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M5 20c0-3.5 3.1-6 7-6s7 2.5 7 6" />
    <path d="M16.5 13.5l1.5 1.5-1.5 1.5" />
    <path d="M18 15h-3" />
  </svg>
);

export const PatientStatementsIcon = ({
  size,
  color,
  strokeWidth,
  className,
} = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="12" y2="17" />
    <circle cx="16" cy="17" r="2" />
    <path d="M14 17h-2" />
  </svg>
);

export const DataImportIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
    <rect x="3" y="15" width="18" height="2" rx="1" />
  </svg>
);

export const TasksIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <line x1="9" y1="6" x2="20" y2="6" />
    <line x1="9" y1="12" x2="20" y2="12" />
    <line x1="9" y1="18" x2="20" y2="18" />
    <polyline points="4 6 5 7 7 5" />
    <polyline points="4 12 5 13 7 11" />
    <polyline points="4 18 5 19 7 17" />
  </svg>
);

export const EligibilityIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const IntakeIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1.5" />
    <path d="M8 11h8M8 15h5" />
  </svg>
);

export const ReportsIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
    <line x1="3" y1="20" x2="21" y2="20" />
  </svg>
);

export const SettingsIcon = ({ size, color, strokeWidth, className } = {}) => (
  <svg {...baseProps(size, color, strokeWidth, className)}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
  </svg>
);

const mainTabIconByTitle = {
  Dashboard: DashboardIcon,
  Patients: PatientsIcon,
  Charges: ChargesIcon,
  Submissions: SubmissionsIcon,
  "Insurance Payments": InsurancePaymentsIcon,
  "EOB Parser": EobParserIcon,
  "Patient Payments": PatientPaymentsIcon,
  "Patient Statements": PatientStatementsIcon,
  "Data Import": DataImportIcon,
  Tasks: TasksIcon,
  Eligibility: EligibilityIcon,
  "Patient Intake": IntakeIcon,
  Reports: ReportsIcon,
  Settings: LuSettings,
};

export const getMainTabIconComponent = (tabTitle) =>
  mainTabIconByTitle[tabTitle] ?? null;

